import { render, staticRenderFns } from "./marginIn.vue?vue&type=template&id=3d7b3296&scoped=true"
import script from "./marginIn.vue?vue&type=script&lang=js"
export * from "./marginIn.vue?vue&type=script&lang=js"
import style0 from "./marginIn.vue?vue&type=style&index=0&id=3d7b3296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7b3296",
  null
  
)

export default component.exports